import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import "./ModalPopup.css";

function ModalPopupMicrodrama(props) {

    return (
        <>
            <Modal centered show={props.show}>
                <Modal.Body>
                    <b>
                        Are you sure you want to upload the selected MicroDrama CSV file?
                    </b>
                </Modal.Body>

                <Modal.Footer>
                    <Button
                        variant="danger"
                        onClick={props.close}
                    >
                        Close
                    </Button>

                    <Button
                        variant="warning"
                        onClick={props.submit}
                    >
                        Submit
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default ModalPopupMicrodrama;